import { SVGProps } from "react";

export function TransferIcon({
  size = 24,
  color = "currentColor",
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...(props as any)}
    >
      <path
        d="M2 7H20H2ZM16 2L21 7L16 12M22 17H4H22ZM8 12L3 17L8 22"
        fill={color}
      />
      <path
        d="M2 7H20M16 2L21 7L16 12M22 17H4M8 12L3 17L8 22"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
}
